import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import './floatingActionButton.css';

const floatingActionButton = () => {
    return ( 
        <div className="floatingActionButton" onClick={() => window.open("https://api.whatsapp.com/send?phone=41996074017")}>
            <FontAwesomeIcon className='contactsPhoneIcon' icon={faWhatsapp}/>
        </div>
    );
}

export default floatingActionButton;